// extracted by mini-css-extract-plugin
export default {"bimOtherTable":"BimWorkOrderOthersPrice_bimOtherTable__BYyWz"};